import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServicePage from './pages/ServicePage';
import GalleryPage from './pages/GalleryPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ForbiddenPage from './pages/ForbiddenPage';
import NotFoundPage from './pages/NotFoundPage';
import { servicePages } from './data/siteData';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/ydelser" element={<ServicesPage />} />
          <Route path="/ydelser/traeterrasser" element={<ServicePage config={servicePages.traeterrasser} />} />
          <Route path="/ydelser/renovering" element={<ServicePage config={servicePages.renovering} />} />
          <Route path="/ydelser/tagudskiftning" element={<ServicePage config={servicePages.tagudskiftning} />} />
          <Route path="/ydelser/vinduer-og-doere" element={<ServicePage config={servicePages['vinduer-og-doere']} />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/om-rs-byg" element={<AboutPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
